goog.provide('el8.appchart.mainFeeds.actions');

goog.require('el8.app.shared.dialog.viewInlinePdf');
goog.require('el8.appchart.dialog.docTags');
goog.require('el8.appchart.dialog.ordermed.document');
goog.require('el8.appchart.dialog.ordermed.fulfillRx');
goog.require('el8.appchart.dialog.plrPreview');
goog.require('el8.appchart.dialog.rxDownloadFills');
goog.require('el8.appchart.dialog.rxRefillRequestDetail');
goog.require('el8.appchart.dialog.viewInlineCda');
goog.require('el8.appchart.dialog.visitNoteEdit');
goog.require('el8.appchart.dialog.viewInlineHl7');
goog.require('el8.appchart.letters.dialog.resendLetterWithNewUnreadAlertNotification');
goog.require('el8.appchart.mainFeeds.menu');
goog.require('el8.appchart.medsHx.main');
goog.require('el8.appchart.medsMgr');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.mgr.orderForm');
goog.require('el8.appchart.mgr.thirdpane');
goog.require('el8.appchart.permissions');
goog.require('el8.appchart.showItemDetail');
goog.require('el8.appchart.visitNote.billDialogMgr');
goog.require('el8.appservice.notifier');
goog.require('el8.appshared.dialog.approveControlledMed');
goog.require('el8.appshared.dialog.approveControlledMedPrintOnly');
goog.require('el8.appshared.dialog.refileRxRefill');
goog.require('el8.appshared.feedItemActions');
goog.require('el8.appshared.feedItemActionsNew');
goog.require('el8.appshared.feedItemPlrActions');
goog.require('el8.appshared.message');
goog.require('el8.appshared.rxRefillRequest');
goog.require('el8.data.base');
goog.require('el8.data.educationalHandouts');
goog.require('el8.model.identify');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.fetch');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.ptImmunizationDeclines');
goog.require('el8.ptdata.rxRefillRequests');
goog.require('el8.service.urls');
goog.require('el8.shared.commentReplyForm');
goog.require('el8.template.app.shared.viewInlinePdf');
goog.require('el8.template.ptdata.letters');
goog.require('el8.tourguide.InfoBox');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.util.amplitude.immunizationHelpers');
goog.require('el8.util.amplitude.letterHelpers');
goog.require('el8.util.amplitude.prescriptionFormHelpers');
goog.require('el8.util.amplitude.orderHelpers');
goog.require('el8.util.amplitude.patientFormHelpers');
goog.require('el8.util.consts');
goog.require('el8.marketing.providerPassportLeadGen');

/**
 * This is an accessory file for chartRenderer.js and reqActRenderer.js, which both construct
 * arguments to pass into the chart/req act renderer
 */

(function() {
    // TODO NewChartFeed: clean up reqActButtons and buttons below
    //
    // This defines the optional actions link and menu link for each item type for RA only
    //
    el8.appchart.mainFeeds.actions.reqActActionsNew = function(item) {
        var actionLink = null;
        var secondActionLink = null; // overrides the hasActionsMenu
        var hasActionsMenu = null;
        var mClass = item.getModelClass();

        // Only return VNs for tease
        if (el8Globals['TEASE'] && mClass !== 'VisitNote') { return {}; }

        switch(mClass) {
            case "Report":
                // Users with Letters on see a set of buttons at the bottom of the item,
                // show sign off link only to those users without letters on
                if (el8.data.currUser.isPhysician() && !item.isSignedOff() && !el8Globals.FEATURES.Letters) {
                    actionLink = {name: 'Sign', htmlClass: 'chartSignOffTrigger feedSignoff'};
                }
                hasActionsMenu = true;
                break;

            case "LabOrder":
                if (item.getSubmissionState() === 'failed') {
                    actionLink = {name: 'Dismiss', htmlClass: 'eorder-error-dismiss-trigger'};
                }
                if (item.isSignedOff()) { hasActionsMenu = true; }
                break;
            case "ImagingOrder":
            case "SleepOrder":
            case "CardiacOrder":
            case "PulmonaryOrder":
            case "ReferralOrder":
                // Non-med orders: signed orders show an action menu, unsigned orders show nothing
                // TODO: check how a signed order would be in RA. If they can't be there, remove this block.
                if (item.isSignedOff()) { hasActionsMenu = true; }
                break;

            case "MedOrder":
                // Meds need to be adjusted slightly to the new paradigm:
                //
                // - Always show the actions menu (to all users)
                //   - Always show the print link in the menu
                // - The first link will be:
                //   - If the item need filled && ERx is on && it's not controlled: show ePrescribe trigger
                //   - If there was an error, show Resend if retriable or dismiss

                // Unsigned medorders have no menus
                if (!item.isSignedOff()) { break; }

                if (item.isNeedsFulfillment() &&
                    el8Globals['FEATURES']['ERx'] &&
                    !item.getMedication().isControlled() &&
                    el8.appchart.permissions.allow('prescribeMeds')) {

                    actionLink = {name: 'ePrescribe', htmlClass: 'eRxTrigger'};
                } else if (item.getFulfillmentMgr().isLatestCancelRequiringAction() &&
                           el8.appchart.permissions.allow('prescribeMeds')) {
                     if (!item.getFulfillmentMgr().getCurrentCancel().isDismissed()) {
                         actionLink = {name: 'Dismiss', htmlClass: 'erx-error-dismiss-trigger'};
                     }
                } else if (item.getFulfillmentMgr().isLatestERxError() &&
                           el8.appchart.permissions.allow('prescribeMeds')) {
                    var latestERx = item.getFulfillmentMgr().getLatestERx();
                    if (latestERx.isRetriable()) {
                        actionLink = {name: 'Resend', htmlClass: 'erx-error-resend-trigger'};
                    } else if (!latestERx.isDismissed()) {
                        actionLink = {name: 'Dismiss', htmlClass: 'erx-error-dismiss-trigger'};
                    }

                }
                hasActionsMenu = true; // all users
                break;

            case 'RxRefillRequest':
                actionLink = {name: 'Change Pt', htmlClass: 'rx-refill-refile-trigger'};
                break;

            case 'DenialMedOrder':
                actionLink = {name: 'Remove', htmlClass: 'denial-remove-trigger'};
                break;

            case "RxHistoryDownloadSummary":
                // Some changes here: for unsigned items the first link is 'sign' and the menu is always shown
                // If MedsHxIgnore is on, there's an additional 'Sign Off & Do NOT Add to Med Lists' that
                // added to the menu
                if (el8.appchart.permissions.allow('acknowledgeRxDownloads') && !item.isSignedOff()) {
                    actionLink = {name: 'Sign', htmlClass: 'acknowledge-rx-download-trigger'};
                }
                hasActionsMenu = true; // all users
                break;

            case "VisitNote":
                // VNs are a special case in that they currenly only show actions if the note has
                // a bill and the billingStatus==el8.util.consts.BILLING_STATUS.UnresolvedError.
                // In the actions menu the 'edit bill' option is only shown to the signer and
                // billing delegates. This seems like an exception to those rules. This was
                // apparently the only place where one can acknowledge / dismiss a bill. Added
                // added acknowledge to the menu as well.
                var bill = item.getBill();
                if (bill && bill.getBillingStatus() === el8.util.consts.BILLING_STATUS.UnresolvedError) {
                    actionLink = {name: 'Edit Bill', htmlClass: 'edit-bill-trigger'};
                    secondActionLink = {name: 'Acknowledge', htmlClass: 'acknowledge-bill-trigger'};
                }
                break;

            case "MessageThread":
                if (item.isSignedOff()) {
                    if (!item.isReviewed() && item.isAcknowledgeableBy(el8.data.currUser.getId())) {
                        actionLink = {name: 'Acknowledge', htmlClass: 'chartAcknowledgeTrigger'};
                    }
                } else {
                    if (item.canUserSign()) {
                        actionLink = {name: 'Sign', htmlClass: 'chartSignOffTrigger'};
                    } else if (item.isStaffOnly()) {
                        var newOfficeMessages = el8Globals.FEATURES.NewOfficeMessages;
                        actionLink = {name: newOfficeMessages ? 'Mark Complete' : "Acknowledge for Group", htmlClass: 'chartSignOffTrigger'};
                    }
                }
                hasActionsMenu = true;
                break;

            case "Letter":
                if (item.isSignedOff()) {
                    var isFailedFax = (item.getFaxStatus() === 'failed' && item.isFailureUnacknowledged());
                    if (isFailedFax || item.getNewCommentCount()) {
                        // Acknowledge for failed faxes and/or new comments
                        actionLink = {name: 'Acknowledge', htmlClass: 'acknowledge-letter-trigger'};
                    }
                    hasActionsMenu = true;
                }
                break;

            case "LetterReceipt":
                if (!item.isSignedOff()) {
                    actionLink = {name: 'Sign', htmlClass: 'sign-letter-receipt'};
                } else if (item.getNewCommentCount()) {
                    actionLink = {name: 'Acknowledge', htmlClass: 'acknowledge-comments-trigger'};
                }
                hasActionsMenu = true;
                break;

            case "IncomingDirectMessage":
                actionLink = {name: 'Sign', htmlClass: 'signoff-direct-message-trigger'};
                secondActionLink = {name: 'Remove', htmlClass: 'remove-direct-message-trigger'};
                hasActionsMenu = false;
                break;

            case "UnreadLetterNotification":
                // TODO: needs testing
                if (!item.isSignedOff()) {
                    if (item.getLetter().getDeliveryMethod() !== 'emr') {
                        actionLink = {name: 'Resend', htmlClass: 'resend-letter-trigger'};
                    }
                    hasActionsMenu = true;
                } else {
                    actionLink = {name: 'Remove', htmlClass: 'remove-unread-letter-notification'};
                }
                break;

            case "XmlPatientSummary":
                hasActionsMenu = true;
                break;

            case "NonvisitNote":
                // we only show NonvisitNotes actions if this is a direct message nonvisitnote
                // otherwise, we don't show any action link, and user'd click on the title to
                // bring up the unfinished nonvisitnote to work on then sign-off
                if (!item.isSignedOff()) {
                    var noteType = el8.data.nonvisitNoteTypes.getById(item.getNoteTypeId());
                    if (noteType.getName().toUpperCase() === 'DIRECT') {
                        actionLink = {name: 'Sign', htmlClass: 'signoff-direct-message-nonvisit-note-trigger'};
                        secondActionLink = {name: 'Remove', htmlClass: 'remove-direct-message-nonvisit-note-trigger'};
                    } else {
                        // do nothing otherwise
                    }
                    hasActionsMenu = false;
                }
                break;

            case 'PatientCollaboratorNotification':
                if (!item.isSignedOff()) {
                    if (el8Globals.FEATURES.PLR4Everyone && item.getEventType() === 'plr4all_invited') {
                        actionLink = {name: 'Accept', htmlClass: 'accept-invite-plr-notification'};
                        secondActionLink = {name: 'Decline', htmlClass: 'decline-invite-plr-notification'};
                        hasActionsMenu = false;
                    } else {
                        actionLink = {name: 'Acknowledge', htmlClass: 'acknowledge-plr-notification'};
                        hasActionsMenu = false;
                    }
                } else {
                    hasActionsMenu = true;
                }
                break;
            case 'VipAccessNotification':
                if (!item.isSignedOff()) {
                    // The primary provider can acknowledge these notifications - no one else can
                    if (el8.data.currUser.isPhysician() &&
                        (el8.ptdata.currPatient.getPrimaryPhysicianUserId() === el8.data.currUser.getId())) {
                        actionLink = {name: 'Acknowledge', htmlClass: 'acknowledge-vip-access-notification'};
                    }
                    hasActionsMenu = false;
                }
                break;

            case 'PmpCheckNotification':
                hasActionsMenu = false;  // Nothing for now
                break;
            case "DocumentReminderNotification":
                hasActionsMenu = true;
                break;

            } // switch
        return {
            actionLink: actionLink,
            secondActionLink: secondActionLink,
            hasActionsMenu: hasActionsMenu
        };
    };

    /**
     * Most of the time, this just returns the same thing as el8.appchart.mainFeeds.actions.buttons,
     * but it gives us the option to have different buttons for items requiring action and items
     * in the chart, when a given item appears in both places at once.
     */
    el8.appchart.mainFeeds.actions.reqActButtons = function(item) {
        if (item.getModelClass() === 'VisitNote') {
            var buttonsInfo = [];
            buttonsInfo.push({ name: 'Edit Bill', htmlClass: 'edit-bill-trigger', isRealButton: true });
            buttonsInfo.push({ name: 'Acknowledge', htmlClass: 'acknowledge-bill-trigger', isRealButton: true });
            return buttonsInfo;
        }
        return el8.appchart.mainFeeds.actions.buttons(item);
    };

    var currUserIsBillDelegateOfSigner = function(signUserId) {
        // The "true" argument = don't fetch from server:
        //
        // We've already loaded the practiceUser set locally at the start of appchart.js,
        // so if we don't get a result, this person is either A. in another practice or
        // B. has been deactivated and we stopped loading inactive users on chart load
        // (as of 5/15 we load inactive users too). In either case, we cannot be their
        // bill delegate.
        var signUser = el8.data.practiceUsers.getById(signUserId, true);
        if (!signUser) { return false; }

        return _.contains(el8.data.currUser.getBillDelegatingPhysicianIds(), signUser.getStaffId());
    };

    /**
     * Controls buttons for chart items
     */
    el8.appchart.mainFeeds.actions.buttons = function(item) {
        var mClass = item.getModelClass();
        var buttonsInfo = [];
        if (el8Globals['TEASE'] && mClass !== 'VisitNote') { return []; }

        switch(mClass) {
            case 'VisitNote':
                if (item.isPreview() && (!item.isSignedOff() || item.getCurrentEditId())) {
                    if (el8.data.currUser.isPhysician()) {
                        if (!item.isSignedOff()) {
                            buttonsInfo.push({ name: 'Sign Off', htmlClass: 'signOffTrigger', isRealButton: true });
                        } else if (item.getCurrentEditId()) {
                            buttonsInfo.push({ name: 'Sign Amended', htmlClass: 'amend-sign-off-trigger', isRealButton: true });
                        }
                    }
                    if (!item.isSignedOff()) {
                        buttonsInfo.push({ name: 'Edit', htmlClass: 'editTrigger', isRealButton: true });
                        buttonsInfo.push({ name: 'Print', htmlClass: 'print-note-trigger', isRealButton: false });

                    } else if (item.getCurrentEditId()) {
                        buttonsInfo.push({ name: 'Edit', htmlClass: 'amend-edit-trigger', isRealButton: true });
                        buttonsInfo.push({ name: 'Print', htmlClass: 'amend-print-trigger', isRealButton: false });
                    }
                } else {
                    buttonsInfo = [];
                    if (item.getSignUserId() === el8.data.currUser.getId()) {
                        buttonsInfo.push({ name: 'Edit', htmlClass: 'choose-edit-note-trigger', hasDropdown: true, isLink: true });
                    } else if (currUserIsBillDelegateOfSigner(item.getSignUserId())) {
                        buttonsInfo.push({ name: 'Edit Bill', htmlClass: 'edit-bill-trigger', isLink: true });
                    }
                    buttonsInfo.push({ name: 'Print', htmlClass: 'choose-print-note-trigger', hasDropdown: true, isLink: true });
                    if (el8Globals.FEATURES.Letters) {
                        buttonsInfo.push({ name: 'Send Note', htmlClass: 'send-letter-trigger', hasDropdown: true, isLink: true });
                    }
                    buttonsInfo.push({ name: 'More Actions', htmlClass: 'visit-note-more-trigger', hasDropdown: true, isLink: true });
                }
                break;

            case 'RxRefillRequest':
                buttonsInfo.push({
                    name: 'Change Pt',
                    htmlClass: 'rx-refill-refile-trigger'
                });
                break;

            case 'DenialMedOrder':
                buttonsInfo.push({
                    name: 'Remove',
                    htmlClass: 'denial-remove-trigger'
                });
                break;

            case "MessageThread":
                if (item.isSignedOff()) {
                    if (!item.isReviewed() && item.isAcknowledgeableBy(el8.data.currUser.getId())) {
                        buttonsInfo.push({
                            name: 'Acknowledge',
                            htmlClass: 'chartAcknowledgeTrigger',
                            isRealButton: true
                        });
                    }
                } else {
                    // If not signed off...
                    if (item.canUserSign()) {
                        buttonsInfo.push({
                            name: 'Sign Off',
                            htmlClass: 'chartSignOffTrigger',
                            isRealButton: true
                        });
                    }
                    else if (item.isStaffOnly()) {
                      var newOfficeMessages = el8Globals.FEATURES.NewOfficeMessages;
                      buttonsInfo.push({
                          name: newOfficeMessages ? 'Mark Complete' : "Acknowledge for Group",
                          htmlClass: 'chartSignOffTrigger',
                          isRealButton: true
                      });
                    }
                }
                buttonsInfo.push({
                    name: 'Actions',
                    htmlClass: 'chart-feed-actions-trigger',
                    hasDropdown: true
                });

                break;

            case "RxHistoryDownloadSummary":
                if (el8.appchart.permissions.allow('acknowledgeRxDownloads') && !item.isSignedOff()) {
                    if (el8Globals.FEATURES['MedsHxIgnore']) {
                        buttonsInfo.push({
                            name: 'Sign Off',
                            htmlClass: 'acknowledge-rx-download-trigger',
                            isRealButton: true
                        });
                        buttonsInfo.push({
                            name: 'Sign Off & Do NOT Add to Med Lists',
                            htmlClass: 'acknowledge-no-merge-rx-download-trigger',
                            isRealButton: true
                        });
                    } else {
                         buttonsInfo.push({
                            name: 'Sign Off',
                            htmlClass: 'acknowledge-rx-download-trigger',
                            isRealButton: true
                        });
                   }
                }
                buttonsInfo.push({
                    name: 'Actions',
                    htmlClass: 'chart-feed-actions-trigger',
                    hasDropdown: true
                });
                break;

            case "Letter":
                if (item.isSignedOff()) {
                    var isFailedFax = (item.getFaxStatus() === 'failed' && item.isFailureUnacknowledged());
                    if (isFailedFax || item.getNewCommentCount()) {
                        // Acknowledge for failed faxes and/or new comments
                        buttonsInfo.push({
                            name: 'Acknowledge',
                            htmlClass: 'acknowledge-letter-trigger',
                            isRealButton: true
                        });
                    }

                    buttonsInfo.push({
                        name: 'Actions',
                        htmlClass: 'chart-feed-actions-trigger',
                        hasDropdown: true
                    });
                }
                break;

            case "LetterReceipt":
                if (!item.isSignedOff()) {
                    buttonsInfo.push({
                        name: 'Sign Off',
                        htmlClass: 'sign-letter-receipt',
                        isRealButton: true
                    });
                } else if (item.getNewCommentCount()) {
                    buttonsInfo.push({
                        name: 'Acknowledge',
                        htmlClass: 'acknowledge-comments-trigger',
                        isRealButton: true
                    });
                }
                buttonsInfo.push({
                    name: 'Actions',
                    htmlClass: 'chart-feed-actions-trigger',
                    hasDropdown: true
                });
                break;
            case "UnreadLetterNotification":
                if (!item.isSignedOff()) {
                    if (item.getLetter().getDeliveryMethod() !== 'emr') {
                        buttonsInfo.push({
                            name: 'Resend',
                            htmlClass: 'resend-letter-trigger',
                            isRealButton: true
                        });
                    }
                    buttonsInfo.push({
                        name: 'Actions',
                        htmlClass: 'chart-feed-actions-trigger',
                        hasDropdown: true
                    });
                } else {
                    buttonsInfo.push({
                        name: 'Remove',
                        htmlClass: 'remove-unread-letter-notification',
                        isRealButton: true
                    });
                }
                break;
            case 'PatientCollaboratorNotification':
                if (!item.isSignedOff()) {
                    if (item.getEventType() === 'plr4all_invited') {
                        buttonsInfo.push({
                            name: 'Accept',
                            htmlClass: 'accept-invite-plr-notification',
                            isRealButton: true
                        });
                        buttonsInfo.push({
                            name: 'Decline',
                            htmlClass: 'decline-invite-plr-notification',
                            isRealButton: true
                        });
                    } else {
                        buttonsInfo.push({
                            name: 'Acknowledge',
                            htmlClass: 'acknowledge-plr-notification',
                            isRealButton: true
                        });
                    }
                }
                break;
            case 'VipAccessNotification':
                if (!item.isSignedOff()) {
                    buttonsInfo.push({
                        name: 'Acknowledge',
                        htmlClass: 'acknowledge-vip-access-notification',
                        isRealButton: true
                    });
                }
                break;
            case "NonvisitNote":
            case "LabOrder":
            case "ImagingOrder":
            case "SleepOrder":
            case "CardiacOrder":
            case "PulmonaryOrder":
            case "ReferralOrder":
            case "MedOrder":
                if (!item.isSignedOff()) {
                    // If not signed off, don't show any buttons
                    break;
                }
            case "Report":
                if (!item.isSignedOff() && !el8Globals.FEATURES.Letters && item.isSignOffAllowed()) {
                    var label = el8.data.currUser.isPhysician() ? 'Sign Off' : 'Mark as Reviewed';
                    // users with Letters on should see a set of buttons at the bottom of the report-item
                    buttonsInfo.push({
                        name: label,
                        htmlClass: 'chartSignOffTrigger feedSignoff',
                        isRealButton: true
                    });
                }
            //case 'DocumentAddendum':
            /* falls through */
            default:
                if (el8.data.currUser.isPhysician()) {
                    if (el8.model.identify.isPrescription(item)) {
                        if (item.isNeedsFulfillment()) {
                            if (el8.appchart.permissions.allow('prescribeMeds')) {
                                if (el8Globals['FEATURES']['ERx'] && !item.getMedication().isControlled()) {
                                    buttonsInfo.push({
                                        name: 'ePrescribe',
                                        htmlClass: 'eRxTrigger'
                                    });
                                }
                            }
                            buttonsInfo.push({
                                name: 'Print',
                                htmlClass: 'printScriptTrigger'
                            });
                        } else if (item.getFulfillmentMgr().isLatestCancelRequiringAction()) {
                            if (el8.appchart.permissions.allow('prescribeMeds')) {
                                if (!item.getFulfillmentMgr().getCurrentCancel().isDismissed()) {
                                    buttonsInfo.push({
                                        name: 'Dismiss',
                                        htmlClass: 'erx-error-dismiss-trigger'
                                    });
                                }
                            }
                            buttonsInfo.push({
                                name: 'Print',
                                htmlClass: 'printScriptTrigger'
                            });
                        } else if (item.getFulfillmentMgr().isLatestERxError()) {
                            if (el8.appchart.permissions.allow('prescribeMeds')) {
                                var latestERx = item.getFulfillmentMgr().getLatestERx();

                                if (latestERx.isRetriable()) {
                                    buttonsInfo.push({
                                        name: 'Re-Send',
                                        htmlClass: 'erx-error-resend-trigger'
                                    });
                                }

                                if (!latestERx.isDismissed()) {
                                    buttonsInfo.push({
                                        name: 'Dismiss',
                                        htmlClass: 'erx-error-dismiss-trigger'
                                    });
                                }
                            }
                            buttonsInfo.push({
                                name: 'Print',
                                htmlClass: 'printScriptTrigger'
                            });
                        }
                    }
                }
                buttonsInfo.push({
                    name: 'Actions',
                    htmlClass: 'chart-feed-actions-trigger',
                    hasDropdown: true
                });
                break;

        }

        return buttonsInfo;
    };

    /* Helper functions for the buttons lists or click maps */
    var unsignedItemTrigger = function($target, itemTypeStr, showFn) {
        var fid = $target.attr('_fid');
        var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid), true); // force fetch new
        if (item && !item.isSignedOff() && !item.isDeleted()) {
            showFn(item);
        } else {
            el8.uiwidget.alert('This '+itemTypeStr+' cannot be edited as it was signed or deleted in another window.');
            el8.appchart.mainFeeds.reqAct.update();
        }
        return false;
    };

    var signAndSendReport = function($target, letterType) {
        var itemId = $target.attr('data-id');
        var report = el8.ptdata.fetch({fetchId: itemId});
        el8.appshared.signOff(report, function() {
            el8.appchart.dialog.reports.hide();
            el8.appchart.mgr.thirdpane.attachToLetter({
                type: letterType,
                attachmentId: report.getId()
            });
        });
    };

    var showAddEditAmendmentRequestDialog = function(note) {
        el8.appchart.dialog.addEditAmendmentRequest.show({
            getAmendmentRequestFn: function() {
                return note.getAmendmentRequest();
            },
            saveAmendmentRequestFn: function(_request, saveCb) {
                note.saveAmendmentRequest({
                    amendmentRequest: _request,
                    successCb: function(request) {

                        // Refresh display of visit note in chart feed
                        el8.ptdata.visitNotes.trigger(EVENTS.UPDATED, note);

                        if (request.isAccepted()) {
                            el8.appchart.mgr.notes.amendVisitNote(note);
                        }
                        if (saveCb) { saveCb(); }
                    }
                });
            }
        });
    };


    el8.appchart.mainFeeds.actions.clickMap = {

        '.resend-letter-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.letters.dialog.resendLetterWithNewUnreadAlertNotification.show(item);
            return false;
        },
        '.remove-unread-letter-notification': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.ptdata.unreadLetterNotifications.deleteItem(item);
            return false;
        },
        '.item-details-trigger': function($target) {
            var id = $target.data('id');
            if (el8.model.idToModelClass(id) === 'Handout') {
                el8.data.educationalHandouts.downloadById(id);
            } else {
                // Pass in the $li for possible recentering
                el8.appchart.showItemDetail(id, $target.closest('li'));
            }
            return false;
        },
        '.plr-item-details-trigger': function($target) {
            var id = $target.data('id');
            el8.appchart.dialog.plrPreview.show(id);
        },
        '.details-trigger': function($target) {
            /* TODO should replace this with the item-details-trigger */
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var $elt = $target.closest('li');

            if (el8.model.identify.isPatientFormCollection(item)) {
              el8.util.amplitude.logEvent('practice views patient form', {
                'form id': item.getFormCollection().form_id
              });
            }

            // $elt optional and used to recenter when reports window is opened
            el8.appchart.showItemDetail(item, $elt);
            return false;
        },
        '.plr-dialog-trigger': function($target) {
            var id = $target.data('id');
            el8.appchart.dialog.plrPreview.show(id);
        },
        '.view-inline-pdf': function($target) {
            var id = $target.data('id');
            el8.app.shared.dialog.viewInlinePdf.show({
                docFileId: id
            });
            if (el8Globals.PASSPORT_EMR && $target.hasClass('clinical-profile')) {
                var lhsBubble = new el8.tourguide.InfoBox();
                lhsBubble.show({
                    styleClass: 'el8FTUEBox',
                    contentFn: el8.template.app.shared.viewInlinePdf.lhsFtueBubble,
                    height: 105,
                    width: 225,
                    left: $('#refBoard').width(),
                    top: 150
                });
                lhsBubble.getContainer().on('click', '.bubble-close-trigger',  function() {
                    lhsBubble.hide();
                    lhsBubble = null;
                });
            }
        },
        '.view-xml-summary': function($target) {
            var id = $target.data('id');
            el8.appchart.dialog.viewInlineCda.show({
                summaryId: id
            });
        },
        '.view-hl7-message': function($target) {
            var id = $target.data('id');
            el8.appchart.dialog.viewInlineHl7.show({
                  messageId: id
            });
        },
        '.comment-reply-trigger': function($target) {
            var docId = $target.data('doc-id');

            el8.shared.commentReplyForm.show({
                container: $target.closest('.letter-item, .letter-receipt-item'),
                docId: docId,
                sendCallback: function() {
                    el8.marketing.providerPassportLeadGen.init({});
                }
            });
        },

        '.reopen-comments-trigger': function($target) {
            var id = $target.data('id');
            var cb = function() { el8.appservice.notifier.notify('Passport response thread reopened'); };
            var modelClass = el8.model.idToModelClass(id);

            if (modelClass === 'LetterReceipt') {
                el8.ptdata.letterReceipts.getById(id).reopenThread(cb);
            } else if (modelClass === 'Letter') {
                el8.ptdata.letters.getById(id).reopenThread(cb);
            }
        },

        // pt-sent letter receipts only
        '.sign-and-close-pt-comments-trigger': function($target, feed) {
            var container = $target.closest('.letter-receipt-item');
            var receiptId = $target.data('doc-id');

            el8.ptdata.letterReceipts.getById(receiptId).sign({
                $receiptElem: container,
                successCb: function() {
                    el8.ptdata.letterReceipts.getById(receiptId).addComment({ closeThread: true });
                }
            });
        },

        // for signed pt-sent letter receipts
        '.close-pt-comments-trigger': function($target, feed) {
            var receiptId = $target.data('doc-id');
            el8.ptdata.letterReceipts.getById(receiptId).addComment({ closeThread: true });
        },

        '.sign-letter-receipt': function($target) {
            var container = $target.closest('.letter-receipt-item');
            var id = container.data('id');
            var receipt = el8.ptdata.letterReceipts.getById(id);
            receipt.sign({
                $receiptElem: container,
                errorCb: function() {
                    el8.ptdata.refreshDocById(id);
                }
            });

            el8.marketing.providerPassportLeadGen.init({});
        },
        '.download-receipt-trigger': function($target, feed) {
            var container = $target.closest('.letter-receipt-item');
            var id = container.data('id');
            var receipt = el8.ptdata.letterReceipts.getById(id);
            window.open(el8.service.urls.get('downloadLetterReceipt', [receipt]));

            el8.marketing.providerPassportLeadGen.init({});
        },
        '.print-receipt-trigger': function($target, feed) {
            var container = $target.closest('.letter-receipt-item');
            var id = container.data('id');
            var receipt = el8.ptdata.letterReceipts.getById(id);
            window.open(el8.service.urls.get('printLetterReceipt', [receipt]));

            el8.marketing.providerPassportLeadGen.init({});
        },
        '.sign-file-letter-receipt': function($target) {
            el8.uiwidget.alert('not yet implemented');
        },
        '.file-receipt-report': function($target) {
            var container = $target.closest('.letter-receipt-item');
            var receiptId = container.data('id');
            var attachmentId = $target.data('id');
            el8.ptdata.letterReceipts.getById(receiptId).fileReport(attachmentId);
        },
        '.add-immunization-trigger': function($target) {
            // in the magic table; "data-name" will hold a CDC Type
            var menu = [];
            menu.push({
                actionText: 'Add Details',
                actionFn: function() {
                    var dlg = el8Globals.FEATURES.IRSubmissions
                      ? el8.appchart.dialog.addEditImmunizationNew
                      : el8.appchart.dialog.addEditImmunization;
                    dlg.show({ vaccineName: $target.attr('data-name') });
                    el8.util.amplitude.logImmunizationTableAction('Add Details');
                }
            });
            menu.push({
                actionText: 'Patient Declined',
                actionFn: function() {
                    var dlg = el8Globals.FEATURES.IRSubmissions
                      ? el8.appchart.dialog.addEditImmunizationNew
                      : el8.appchart.dialog.addEditImmunization;
                    dlg.show({ vaccineName: $target.attr('data-name'), patientDeclined: true });
                    el8.util.amplitude.logImmunizationTableAction('Patient Declined');
                }
            });
            menu.push({
                actionText: 'Patient Has Immunity',
                actionFn: function() {
                    el8.ptdata.ptImmunizationDeclines.addPatientImmunity({
                        cdcType: $target.attr('data-name')
                    });
                    el8.util.amplitude.logImmunizationTableAction('Patient Has Immunity');
                }
            });
            el8.appchart.mainFeeds.menu.display($target, null, {'top': 18, 'left': 80}, menu);

            return false;
        },
        '.re-order-trigger': function($target) {
            var order = el8.ptdata.fetchById($target.data('id'));
            if (order.is('ReferralOrder')) {
                order.reOrderWithLetter({
                    successCb: function(updatedLetter) {
                        el8.appchart.mgr.thirdpane.showLetter({letter: updatedLetter});
                        // manually log create referral event in amplitude
                        el8.util.amplitude.logStartLetter('Referral Reorder', el8.util.consts.REFERRAL_LETTER);
                    }
                });
            } else {
                el8.appchart.mgr.orderForm.reOrderItem(order);
            }
        },
        '.write-message-trigger': function($target) {
            var docId = $target.data('id');
            var item = el8.ptdata.fetchById(docId);
            if (item.is('Report')) {
                // we do some extra handling for reports to display the message in the reports dialog
                el8.appchart.dialog.reports.writeReportMessage(item);
            } else {
                el8.appshared.message.prePopulateNewMessage({
                    toDocId: docId
                });
            }
        },
        '.attach-to-provider': function($target) {
            el8.appchart.mgr.thirdpane.attachToLetter({
                type: el8.util.consts.CONSULTANT_LETTER,
                attachmentId: $target.data('id')
            });
        },
        '.attach-to-passport': function($target) {
            el8.appchart.mgr.thirdpane.attachToLetter({
                type: el8.util.consts.PATIENT_LETTER,
                attachmentId: $target.data('id')
            });
        },
        '.add-edit-tags-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.dialog.docTags.show({doc: item});
            return false;
        },

        // for direct messages
        '.signoff-direct-message-trigger': function($target) {
            var container = $target.closest('.direct-message-item');
            var id = container.data('id');
            var patientId = container.data('patient-id')*1;

            var direct_msg = el8.ptdata.directMessages.getById(id);
            direct_msg.signOff({
                patientId: patientId,
                successCb: function() {
                    el8.appchart.mainFeeds.reqAct.update();
                    el8.appchart.mainFeeds.outstanding.update();
                    el8.appchart.mainFeeds.chart.update();
                },
                errorCb: function() {}
            });
        },
        '.remove-direct-message-trigger': function($target) {
            var container = $target.closest('.direct-message-item');
            var id = container.data('id');
            var patientId = container.data('patient-id')*1;

            el8.uiwidget.confirm("Are you sure you want to delete this incoming direct message from the patient chart?  This action cannot be undone!",
                function() {
                    var direct_msg = el8.ptdata.directMessages.getById(id);
                    direct_msg.deleteItem({
                        patientId: patientId,
                        successCb: function() {
                            el8.appchart.mainFeeds.reqAct.update();
                            el8.appchart.mainFeeds.outstanding.update();
                            el8.appchart.mainFeeds.chart.update();
                        },
                        errorCb: function() {}
                    });
                }
            );
        },


        /**
         * This next section contains req act/outstanding feed / unsigned items triggers
         */
        '.threadReplyTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var cardContainer = $('#patient-feed-container');
            el8.appchart.mainFeeds.reqAct.freeze();
            el8.appchart.mainFeeds.outstanding.freeze();
            el8.appshared.message.showReplyMessageForm(item, cardContainer, {
                closeFn: function() {
                    el8.appchart.mainFeeds.reqAct.unfreeze();
                    el8.appchart.mainFeeds.outstanding.unfreeze();
                }
            });
            return false;
        },
        '.chartSignOffTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            if (item.is('MessageThread') && !item.hasAnyOneElseReplied()) {
                var str = el8.data.currUser.isPhysician() ? 'Confirm message sign off?' : 'Confirm filing this message into chart?';
                el8.uiwidget.confirm(str+' This action cannot be undone. Other recipients can still acknowledge this message.',
                    function() {
                        el8.appshared.signOff(item, function() {
                            el8.appchart.dialog.reports.hide();
                        });
                    }
                );
            } else {
                el8.appshared.signOff(item, function() {
                    el8.appchart.dialog.reports.hide();
                });
            }
            if (item.is('Report')) {
                el8.util.amplitude.logFormReview();
                if (!el8.data.currUser.isPhysician()){
                    el8.util.amplitude.logStaffFormReview();
                }
            }
            return false;
        },
        '.chartAcknowledgeTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appshared.message.acknowledgeThread(item);
            return false;
        },
        '.visit-note-trigger': function($target) {
            var showFn = function(item) {
                el8.appchart.mgr.notes.showVisitNote({'note': item});
            };
            return unsignedItemTrigger($target, 'note', showFn);
        },
        '.visit-note-edit-trigger': function($target) {
            var showFn = function(item) {
                var note = item.getVisitNote(true); // force fetch from server
                el8.appchart.mgr.notes.amendVisitNote(note);
            };
            return unsignedItemTrigger($target, 'amendment', showFn);
        },
        '.nonvisit-note-trigger': function($target) {
            var showFn = function(item) {
                el8.appchart.mgr.notes.showNonvisitNote({'note': item});
            };
            return unsignedItemTrigger($target, 'note', showFn);
        },
        '.signoff-direct-message-nonvisit-note-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            $.el8_ajax({
                url: el8.service.urls.get('nonvisitNoteSign', [item.getId()]),
                type: 'POST',
                success: function(data) {
                    el8.ptdata.nonvisitNotes.create(data);
                }
            });
        },
        '.remove-direct-message-nonvisit-note-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.uiwidget.deleteConfirm("incoming direct message",
                function() { el8.ptdata.nonvisitNotes.forceDeleteItem(item); }
            );
        },
        '.unsigned-letter-trigger': function($target) {
            var showFn = function(item) {
                el8.appchart.mgr.thirdpane.showLetter({letter: item});
            };
            return unsignedItemTrigger($target, 'letter', showFn);
        },
        '.unsigned-order-trigger': function($target) {
            var showFn = function(item) {
                var modelClass = item.getModelClass();
                if (modelClass === 'MedOrder') {
                  el8.appchart.mgr.orderForm.openDraftMedOrders(item);
                } else {
                  el8.appchart.mgr.orderForm.showOrderForm(modelClass, false, { model: item });
                }
            };
            return unsignedItemTrigger($target, 'order', showFn);
        },
        '.acknowledge-bill-trigger': function($target) {
            var fid = $target.attr('_fid');
            var visit = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            visit.dismissBill();
        },
        '.edit-bill-trigger': function($target) {
            var fid = $target.attr('_fid');
            var visit = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.visitNote.billDialogMgr.show({
                visitNote: visit,
                patient: el8.ptdata.currPatient,
                source: 'chart feed',
            });
        },
        '.acknowledge-letter-trigger': function($target) {
            var fid = $target.attr('_fid');
            var letter = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var isFailedFax = (letter.getFaxStatus() === 'failed' && letter.isFailureUnacknowledged());
            var hasNewComments = Boolean(letter.getNewCommentCount());

            // possible values for isFailedFax/hasNewComments should be : TT, TF, FT (not FF)
            // if both are true, we'll queue up the acknowledgments
            if (isFailedFax) {
                letter.dismissFailedFax(function() {
                    if (hasNewComments) { letter.dismissComments(); }
                });
            } else if (hasNewComments) {
                letter.dismissComments();
            }
        },
        '.acknowledge-comments-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            item.dismissComments();
        },
        '.close-letter-comments-trigger': function($target) {
            var letterId = $target.closest('.letter-item').data('id');
            el8.ptdata.letters.getById(letterId).closeThread(function() {
                el8.appservice.notifier.notify('Passport response thread closed');
            });
        },
        '.send-report-patient-trigger': function($target) {
            signAndSendReport($target, el8.util.consts.PATIENT_LETTER);
        },
        '.send-report-consultant-trigger': function($target) {
            signAndSendReport($target, el8.util.consts.CONSULTANT_LETTER);
        },

        /**
         * This next section contains chart feed / signed items triggers
         */
        '.chart-feed-actions-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.mainFeeds.menu.display($target, item, {'top': 18, 'left': 20},
                el8.appshared.feedItemActions(item));
            return false;
        },
        /*
         * TODO NewChartFeed: remove above and feedItemActions after transition
         */
        '.chart-feed-actions-trigger-new': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            // pass the fact that this is fromRA or not to the fn defining the menu
            var fromRA = $target.data('from-ra') || false;

            // Items with two column menus:
            if (el8.model.identify.isVisitNote(item) ||
                el8.model.identify.isReport(item) ||
                el8.model.identify.isPrescription(item) ||
                el8.model.identify.isDiscontinueMedOrder(item)) {
                el8.appchart.mainFeeds.twoColumnMenu.display(
                    $target,
                    item,
                    {'top': 18, 'left': -5},
                    el8.appshared.feedItemActionsNew(item, fromRA, 'chronological record')
                );
            } else {
                el8.appchart.mainFeeds.menu.display(
                    $target,
                    item,
                    {'top': 18, 'left': -5},
                    el8.appshared.feedItemActionsNew(item, fromRA, 'chronological record')
                );
            }

            return false;
        },

        '.chart-feed-plr-actions-trigger-new': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.plrdata.getByFeedId(fid);

            // Items with two column menus:
            el8.appchart.mainFeeds.menu.display(
                $target,
                item,
                {'top': 18, 'left': -5},
                el8.appshared.feedItemPlrActions(item)
            );

            return false;
        },

        /**
         * This next section contains chart feed visit note triggers
         */
        '.addToNoteHpiTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var assessmentId = $target.attr('assessmentid')*1;
            var assessment = item.getBulletSets()['Assessment'].getById(assessmentId) ||
                item.getBulletSets()['Assessplan'].getById(assessmentId);
            if (assessment) {
                el8.appchart.mgr.notes.addText(assessment.getText(), 'problem');
            } else {
                UIM && UIM.logError('Tried to Ref (HPI) assessment but could not find it. ID: '+assessmentId);
            }
        },
        '.edit-changes-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var editId = $target.attr('_id') * 1;
            el8.appchart.dialog.visitNoteEdit.show(item, editId);
        },
        /* This is for a previewed, unsigned visit note */
        '.signOffTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            item.sign();
        },
        '.amend-sign-off-trigger': function($target) {
            var fid = $target.attr('_fid');
            var itemId = el8.util.feed.fromFeedItemId(fid).id;
            var note = el8.ptdata.tempVisitNotes.getById(itemId);
            note.sign();
        },
        '.editTrigger': function($target) {
            var fid = $target.attr('_fid');
            var itemId = el8.util.feed.fromFeedItemId(fid).id;
            el8.appchart.visitNote.main.editPreviewedNote(itemId);
        },
        '.amend-edit-trigger': function($target) {
            /* The below looks like a massive amount of hoop jumping, but we do
             * need to refetch the note from the edit, and we can only get the edit ID
             * from the $target's id */
            var fid = $target.attr('_fid');
            var itemId = el8.util.feed.fromFeedItemId(fid).id;
            var editId = el8.ptdata.tempVisitNotes.getById(itemId).getCurrentEditId();
            var edit = el8.ptdata.visitNoteEdits.getById(editId);
            var note = edit.getVisitNote(true); // force fetch from server
            el8.appchart.mgr.notes.amendVisitNote(note);
        },
        '.amend-print-trigger': function($target) {
            var fid = $target.attr('_fid');
            var itemId = el8.util.feed.fromFeedItemId(fid).id;
            var note = el8.ptdata.tempVisitNotes.getById(itemId);
            note.printNote(false);
            return false;
        },
        '.send-letter-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = [];
            menu.push({
                actionText: 'To Provider (Letter)',
                actionFn: function() {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.CONSULTANT_LETTER,
                        attachmentId: item.getId(),
                        enforceStrictTypeMatch: true
                    });
                }
            });
            menu.push({
                actionText: 'To Provider (Referral)',
                actionFn: function() {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.REFERRAL_LETTER,
                        attachmentId: item.getId(),
                        enforceStrictTypeMatch: true
                    });
                }
            });
            if (el8Globals.FEATURES.PatientPortal) {
                menu.push({
                    actionText: 'To Patient',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.PATIENT_LETTER,
                            attachmentId: item.getId()
                        });
                    }
                });
            }
            el8.appchart.mainFeeds.menu.display($target, item, {'top': 18, 'left': 95}, menu);
            return false;
        },
        '.choose-edit-note-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = [];
            menu.push({
                actionText: 'Amend Note',
                actionFn: function() {
                    el8.uiwidget.confirm("You are about to make changes to a signed off note. All changes will be tracked and logged for auditing and legal purposes. Proceed?",
                        function() { el8.appchart.mgr.notes.amendVisitNote(item); }
                    );
                }
            });
            menu.push({
                actionText: 'Edit Bill',
                actionFn: function() {
                    el8.appchart.visitNote.billDialogMgr.show({
                        visitNote: item,
                        patient: el8.ptdata.currPatient,
                        source: 'chart feed',
                    });
                }
            });
            if (el8Globals.FEATURES.MUReports) {
                menu.push({
                    actionText: (!item.getAmendmentRequest() ? 'Document' : 'Edit') + ' Amendment Request from Patient',
                    actionFn: function() {
                        showAddEditAmendmentRequestDialog(item);
                    }
                });
            }
            el8.appchart.mainFeeds.menu.display($target, item, {'top': 18, 'left': 135}, menu);
            return false;
        },
        '.choose-print-note-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = [];
            menu.push({
                actionText: 'Note',
                actionFn: function() { item.printNote(false); }
            });
            if (item.getBill() && !item.getBill().isEmpty()) {
                menu.push({
                    actionText: 'Note with Billing',
                    actionFn: function() { item.printNote(true); }
                });
            }
            menu.push({
                actionText: 'Clinical Summary of Encounter (MIPS)',
                actionFn: function() { item.printClinicalSummary(); }
            });
            if (item.hasPrintableMeaningfulUse()) {
                menu.push({
                    actionText: (item.getBill() && !item.getBill().isEmpty()) ?
                        'Note with Billing & MIPS Info' :
                        'Note with MIPS Info',
                    actionFn: function() { item.printNote(true, true); }
                });
            }
            if (item.getBulletSets()['Instr'].all().length) {
                menu.push({
                    actionText: 'Patient Instructions',
                    actionFn: function() {
                        var printPath = el8Globals['PATIENT_PATH']+"print/patient-instructions/"+item.getId() + "/";
                        window.open(printPath);
                    }
                });
            }
            menu.push({
                actionText: 'Patient Summary',
                actionFn: function() { item.printPatientSummary(); }
            });
            if (item.getBill() && !item.getBill().isEmpty()) {
                menu.push({
                    actionText: 'Simple Invoice (no Dx)',
                    actionFn: function() { item.printSimplePatientInvoice(); }
                });

                if (!item.getBill().hasUnstructuredDxs()) {
                    menu.push({
                        actionText: 'Claims Invoice (ICD-10)',
                        actionFn: function() { item.printIcd10PatientInvoice(); } // 10s only
                    });
                }
                menu.push({
                    actionText: 'Claims Invoice (ICD-9)',
                    actionFn: function() { item.printIcd9PatientInvoice(); } // 9s only
                });
            }
            if (item.getRxIds().length) {
                menu.push({
                    actionText: 'Re-print Prescribed Scripts',
                    actionFn: function() {
                        el8.ptdata.medOrders.printSet(item.getRxIds(), function() {
                            el8.appchart.mainFeeds.reqAct.remove(item);
                        });
                    }
                });
            }
            el8.appchart.mainFeeds.menu.display($target, item, {'top': 18, 'left': 130}, menu);
            return false;
        },
        '.print-note-trigger': function($target) {
            var fid = $target.attr('_fid');
            var note = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            note.printNote(false);
            return false;
        },
        '.visit-note-more-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = [];
            menu.push({
                actionText: 'Write Message',
                actionFn: function() {
                    el8.appshared.message.prePopulateNewMessage({
                        toDocId: item.getId()
                    });
                }
            });
            menu.push({
                actionText: 'Copy text into new note',
                actionFn: function() {
                    el8.appchart.mgr.notes.cloneExistingNote(item.getId());
                }
            });
            menu.push({
                actionText: 'Add/Edit Tags',
                actionFn: function(item) {
                     el8.appchart.dialog.docTags.show({doc: item});
                 }
             });
            menu.push({
                actionText: 'Remove',
                actionFn: function() {
                    el8.uiwidget.deleteConfirm("note",
                        function() { el8.ptdata.visitNotes.forceDeleteItem(item); }
                    );
                }
            });
            if (item.getImages().length) {
                menu.push({
                    actionText: 'Remove & Re-File Images',
                    actionFn: function() {
                        el8.uiwidget.deleteConfirm("note and send the images back to Incoming Documents",
                            function() { el8.ptdata.visitNotes.forceDeleteItemSendBackImages(item); }
                        );
                    }
                });
            }
            el8.appchart.mainFeeds.menu.display($target, item, {'top': 18, 'left': 80}, menu);
            return false;
        },

        /**
         * Rx-related triggers
         */
        '.eRxTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.dialog.ordermed.fulfillRx.show(null, item);
            return false;
        },
        '.printScriptTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.ptdata.medOrders.printSingle(item);
            return false;
        },
        '.acknowledge-rx-download-trigger': function($target) {
            if (!$target.prop('disabled')) {
                $target.prop('disabled', true);
                var fid = $target.attr('_fid');
                var id = el8.util.feed.fromFeedItemId(fid).id;
                el8.appchart.medsMgr.acknowledgeRxDownloadSummary(id, function() {
                    $target.prop('disabled', false);
                });
                return false;
            }
        },
        '.acknowledge-no-merge-rx-download-trigger': function($target) {
            if (!$target.prop('disabled')) {
                $target.prop('disabled', true);
                var fid = $target.attr('_fid');
                var id = el8.util.feed.fromFeedItemId(fid).id;
                el8.appchart.medsMgr.acknowledgeNoMergeRxDownloadSummary(id, function() {
                    $target.prop('disabled', false);
                });
                return false;
            }
        },
        '.rx-change-request-approve-trigger': function($target) {
            var fid = $target.attr('_fid');
            var id = el8.util.feed.fromFeedItemId(fid).id;
            var pharmacyPrescriptionRequest = el8.ptdata.pharmacyPrescriptionRequests.getById(id);
            el8.util.amplitude.logStartChangeRxResponse(
              'Approve',
              pharmacyPrescriptionRequest.getHumanReadableChangeRequestType(),
              pharmacyPrescriptionRequest.getOriginalMedOrder().isControlled()
            );
            el8React.dispatch.openApprovePrescriptionChangeDialog(id);
        },
        '.rx-change-request-approve-with-modifications-trigger': function($target) {
            var fid = $target.attr('_fid');
            var id = el8.util.feed.fromFeedItemId(fid).id;
            var pharmacyPrescriptionRequest = el8.ptdata.pharmacyPrescriptionRequests.getById(id);
            el8.util.amplitude.logStartChangeRxResponse(
              'Approve with modifications',
              pharmacyPrescriptionRequest.getHumanReadableChangeRequestType(),
              pharmacyPrescriptionRequest.getOriginalMedOrder().isControlled()
            );
            el8React.dispatch.openApprovePrescriptionChangeWithModificationsDialog(id);
        },
        '.rx-change-request-deny-trigger': function($target) {
            var fid = $target.attr('_fid');
            var id = el8.util.feed.fromFeedItemId(fid).id;
            var pharmacyPrescriptionRequest = el8.ptdata.pharmacyPrescriptionRequests.getById(id);
            el8.util.amplitude.logStartChangeRxResponse(
              'Deny & add reason',
              pharmacyPrescriptionRequest.getHumanReadableChangeRequestType(),
              pharmacyPrescriptionRequest.getOriginalMedOrder().isControlled()
            );
            el8React.dispatch.openDenyPrescriptionChangeDialog(id);
        },
        '.rx-prior-auth-yes-trigger': function($target) {
            var fid = $target.attr('_fid');
            var id = el8.util.feed.fromFeedItemId(fid).id;
            var pharmacyPrescriptionRequest = el8.ptdata.pharmacyPrescriptionRequests.getById(id);
            el8.util.amplitude.logStartChangeRxResponse(
                'Yes, prior auth obtained',
                pharmacyPrescriptionRequest.getHumanReadableChangeRequestType(),
                pharmacyPrescriptionRequest.getOriginalMedOrder().isControlled()
            );
            el8React.dispatch.openPrescriptionPriorAuthObtainedDialog(id);
        },
        '.rx-prior-auth-no-payer-denied-trigger': function($target) {
          var fid = $target.attr('_fid');
          var id = el8.util.feed.fromFeedItemId(fid).id;
          var pharmacyPrescriptionRequest = el8.ptdata.pharmacyPrescriptionRequests.getById(id);
          el8.util.amplitude.logStartChangeRxResponse(
            'No, payer denied',
            pharmacyPrescriptionRequest.getHumanReadableChangeRequestType(),
            pharmacyPrescriptionRequest.getOriginalMedOrder().isControlled()
          );
          el8React.dispatch.openPrescriptionPriorAuthPayerDeniedDialog(id);
        },
        '.rx-prior-auth-no-payer-not-contacted-trigger': function($target) {
          var fid = $target.attr('_fid');
          var id = el8.util.feed.fromFeedItemId(fid).id;
          var pharmacyPrescriptionRequest = el8.ptdata.pharmacyPrescriptionRequests.getById(id);
          el8.util.amplitude.logStartChangeRxResponse(
            'No, payer not contacted',
            pharmacyPrescriptionRequest.getHumanReadableChangeRequestType(),
            pharmacyPrescriptionRequest.getOriginalMedOrder().isControlled()
          );
          el8React.dispatch.openPrescriptionPriorAuthPayerNotContactedDialog(id);
        },
        '.rx-refill-detail-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.dialog.rxRefillRequestDetail.show(item);
            return false;
        },
        '.rx-refill-refile-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.util.amplitude.logStartRefileRenewalRequest('Change Pt', item.isMedicationControlled());
            el8.appshared.dialog.refileRxRefill.show(item.getId());
            return false;
        },
        '.rx-refill-approve-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));

            /* Empty the 'deny' and 'edit' containers */
            var $elt = $target.closest('li.feedItem');
            $elt.find('.rx-refill-deny-trigger')
                .removeClass('inlineButtonSelected')
                .addClass('inlineButton');
            $elt.find('.rx-refill-deny-detail').empty();
            $elt.find('.rx-refill-edit-trigger')
                .removeClass('inlineButtonSelected')
                .addClass('inlineButton');
            $elt.find('.rx-refill-edit-detail').empty();

            /* Unfreeze the req act feed */
            el8.appchart.mainFeeds.reqAct.unfreeze();

            el8.util.amplitude.startRenewalRxResponse('Approve', item.isMedicationControlled());
            if (!item.isMedicationControlled() || el8Globals.FEATURES.MDToolboxEPCS) {
                el8.appchart.dialog.ordermed.fulfillRefill.showApprove(item,
                    item.getAuthRefills(), '', true);
            } else {
                if (item.isControlledRefillPrintOnly()) {
                    el8.appshared.dialog.approveControlledMedPrintOnly.show({
                        refill: item,
                        noChange: true
                    });
                } else {
                    el8.appshared.dialog.approveControlledMed.show({
                        refill: item,
                        noChange: true
                    });
                }
            }
            return false;
        },
        '.rx-refill-edit-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.util.amplitude.startRenewalRxResponse('Change Number of Refills', item.isMedicationControlled());
            var $elt = el8.appchart.mainFeeds.reqAct.getRenderItem(item.getId());
            $elt.find('.rx-refill-deny-trigger')
                .removeClass('inlineButtonSelected')
                .addClass('inlineButton');
            $target.removeClass('inlineButton').addClass('inlineButtonSelected');

            /* Empty the 'deny' container; only one can show at a time */
            $elt.find('.rx-refill-deny-detail').empty();
            var editContainer = $elt.find('.rx-refill-edit-detail');
            /* Freeze reqAct feed so changes don't get flushed */
            el8.appchart.mainFeeds.reqAct.freeze();
            el8.appshared.rxRefillRequest.approve(item, editContainer, function() {
                $target.removeClass('inlineButtonSelected').removeClass('inlineButton');
                $elt.find('.rx-refill-deny-trigger').removeClass('inlineButtonSelected').removeClass('inlineButton');
                el8.appchart.mainFeeds.reqAct.unfreeze();
            });
            return false;
        },
        '.rx-refill-deny-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var isControlled = item.isMedicationControlled();
            el8.util.amplitude.startRenewalRxResponse('Deny', isControlled);
            var $elt = el8.appchart.mainFeeds.reqAct.getRenderItem(item.getId());
            if (isControlled) {
                $elt.find('.rx-refill-renew-trigger')
                    .removeClass('inlineButtonSelected')
                    .addClass('inlineButton');
                /* Empty the 'renew' container; only one can show at a time */
                $elt.find('.rx-refill-renew-detail').empty();
            } else {
                $elt.find('.rx-refill-edit-trigger')
                    .removeClass('inlineButtonSelected')
                    .addClass('inlineButton');
                /* Empty the 'edit' container; only one can show at a time */
                $elt.find('.rx-refill-edit-detail').empty();
                }
            $target.removeClass('inlineButton').addClass('inlineButtonSelected');

            var denyContainer = $elt.find('.rx-refill-deny-detail');
            /* Freeze reqAct feed so changes don't get flushed */
            el8.appchart.mainFeeds.reqAct.freeze();
            el8.appshared.rxRefillRequest.deny(item, denyContainer, function() {
                $target.removeClass('inlineButtonSelected').removeClass('inlineButton');
                if (isControlled) {
                    $elt.find('.rx-refill-renew-trigger').removeClass('inlineButtonSelected').removeClass('inlineButton');
                } else {
                    $elt.find('.rx-refill-edit-trigger').removeClass('inlineButtonSelected').removeClass('inlineButton');
                }
                el8.appchart.mainFeeds.reqAct.unfreeze();
            });
            return false;
        },
        '.rx-refill-renew-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.util.amplitude.startRenewalRxResponse('Renew', item.isMedicationControlled());
            var $elt = el8.appchart.mainFeeds.reqAct.getRenderItem(item.getId());
            $elt.find('.rx-refill-deny-trigger')
                .removeClass('inlineButtonSelected')
                .addClass('inlineButton');
            $target.removeClass('inlineButton').addClass('inlineButtonSelected');

            /* Empty the 'deny' container; only one can show at a time */
            $elt.find('.rx-refill-deny-detail').empty();
            var renewContainer = $elt.find('.rx-refill-renew-detail');
            /* Freeze reqAct feed so changes don't get flushed */
            el8.appchart.mainFeeds.reqAct.freeze();
            el8.appshared.rxRefillRequest.renew(item, renewContainer, function() {
                $target.removeClass('inlineButtonSelected').removeClass('inlineButton');
                $elt.find('.rx-refill-deny-trigger').removeClass('inlineButtonSelected').removeClass('inlineButton');
                el8.appchart.mainFeeds.reqAct.unfreeze();
            });
            return false;
        },
        '.denial-remove-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.uiwidget.confirm("Are you sure you want to delete this denial from the patient chart?  This action cannot be undone!",
                function() { el8.ptdata.denialMedOrders.deleteItem(item); }
            );
            return false;
        },
        '.erx-error-resend-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.mainFeeds.reqAct.remove(item);
            el8.ptdata.medOrders.eRxSingle(item, item.getFulfillmentMgr().getLatestPharmacy(), item.getFulfillmentMgr().getLatestServiceLocationId());
            return false;
        },
        '.erx-error-dismiss-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.ptdata.medOrders.dismissERxError(item, function() {
                el8.appchart.mainFeeds.reqAct.remove(item);
            });
            return false;
        },
        '.erx-send-as-cs-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.mgr.orderForm.showMedsOrderForm( false, {
                type: 'New',
                order: item
            }, 'controlled');
            el8.ptdata.medOrders.dismissERxError(item, function() {
                el8.appchart.mainFeeds.reqAct.remove(item);
            });
            return false;
        },
        '.eorder-error-dismiss-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.ptdata.medOrders.dismissEOrderError(item, function() {
                el8.appchart.mainFeeds.reqAct.remove(item);
            });
            return false;
        },
        '.view-fills-trigger': function($target) {
            var summaryItemId = $target.attr('data-id')*1;
            var summaryItem = el8.ptdata.rxHistoryDownloadSummaries.getById(summaryItemId);
            el8.appchart.dialog.rxDownloadFills.show(summaryItem);
            return false;
        },
        '.rx-refill-trigger': function($target) {
            var med = el8.ptdata.fetchById($target.data('id'));
            el8.appchart.mgr.orderForm.refillMedOrder(med);
        },
        '.rx-dose-trigger': function($target) {
            var med = el8.ptdata.fetchById($target.data('id'));
            el8.appchart.mgr.orderForm.changeMedOrder(med);
        },
        '.rx-reorder-trigger': function($target) {
            var med = el8.ptdata.fetchById($target.data('id'));
            el8.appchart.mgr.orderForm.reOrderMedOrder(med);
        },
        '.rx-doc-change-trigger': function($target) {
            var med = el8.ptdata.fetchById($target.data('id'));
            el8.appchart.dialog.ordermed.document.show({
                order: med,
                type: 'DoseChange'
            });
        },
        '.acknowledge-plr-notification': function($target) {
            var container = $target.closest('.plr-notification-item');
            var notification = el8.ptdata.fetchById(container.data('id'));
            notification.acknowledge();
        },
        '.acknowledge-vip-access-notification': function($target) {
            var container = $target.closest('.vip-access-notification-item');
            var notification = el8.ptdata.fetchById(container.data('id'));
            notification.acknowledge();
        },
        '.accept-invite-plr-notification': function($target) {
            var container = $target.closest('.plr-notification-item');
            var notification = el8.ptdata.fetchById(container.data('id'));
            var invitation = el8.ptdata.careTeamProviders.getById(container.data('invite-id'));
            $.el8_ajax({
                type: 'POST',
                data: JSON.stringify({ action: 'accept' }),
                url: el8.service.urls.get('careTeamInvitation', [invitation.getId()]),
                success: function(data) {
                    notification.acknowledge();
                    el8.appservice.notifier.notify("You are now collaborating with " + invitation.getInvitingPhysician().getFullName() + " on this patient's Care Team.");
                    el8.ptdata.ptProviders.load();
                    el8.ptdata.careTeamProviders.load();
                    el8.appchart.providers.main.refreshPatientTeam();
                }
            });
        },
        '.decline-invite-plr-notification': function($target) {
            var container = $target.closest('.plr-notification-item');
            var notification = el8.ptdata.fetchById(container.data('id'));
            var invitation = el8.ptdata.careTeamProviders.getById(container.data('invite-id'));
            $.el8_ajax({
                type: 'POST',
                data: JSON.stringify({ action: 'decline' }),
                url: el8.service.urls.get('careTeamInvitation', [invitation.getId()]),
                success: function(data) {
                    notification.acknowledge();
                    el8.appservice.notifier.notify("You have declined to collaborate with " + invitation.getInvitingPhysician().getFullName() + " on this patient's Care Team.");
                    el8.ptdata.ptProviders.load();
                    el8.ptdata.careTeamProviders.load();
                    el8.appchart.providers.main.refreshPatientTeam();
                }
            });
        },
        '.reminder-notification-fulfill-trigger': function($target) {
            el8.util.amplitude.logOrderReminder('Fulfilled');
            var container = $target.closest('.reminder-notification-item');
            var notification = el8.ptdata.fetchById(container.data('id'));

            // Open the attachment dialog, passing in patientId
            el8.app.shared.dialog.reportAttachments.show({
                callbackFn: function (attachmentItems) {
                    var opts = {};
                    if (attachmentItems.length) { // just one or none
                        var attachment = attachmentItems[0];
                        opts.resolvingDocumentId = attachment.getId();
                    }
                    notification.fulfill(opts);
                    el8.appchart.mainFeeds.reqAct.update();
                    el8.appchart.mainFeeds.chart.update();
                },
                patientId: el8.ptdata.currPatient.getId()
            });

            return false;
        },
        '.reminder-notification-remind-later-trigger': function($target) {
            el8.util.amplitude.logOrderReminder('Remind Later');
            var container = $target.closest('.reminder-notification-item');
            var notification = el8.ptdata.fetchById(container.data('id'));
            notification.remindLater({
                source: 'order reminder button',
                successCb: function() {
                    el8.appchart.mainFeeds.reqAct.update();
                    el8.appchart.mainFeeds.chart.update();
                }
            });
            return false;
        },
        '.prenatal-flowsheet-display-trigger': function($target) {
            var container = $target.closest('.prenatal-flowsheet-visit-measurements');
            var visitMeasurements = el8.ptdata.prenatalFlowsheetVisitMeasurements.getById(container.data('id'));

            el8.appchart.dialog.prenatalFlowsheet.show({'ptPrenatalFlowsheet': visitMeasurements.getFlowsheet()});

            return false;
        }
    };

    if (el8Globals['TEASE']) {
        el8.appchart.mainFeeds.actions.clickMap = {
            '.details-trigger': function($target) {
                var fid = $target.attr('_fid');
                var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
                $(document).trigger('show-item-detail', [item]);
                return false;
            },
            '.item-details-trigger': function($target) {
                var itemId = $target.data('id');
                $(document).trigger('show-item-detail', [itemId]);
                return false;
            },
            'a, button': function($target) {
                if (!$target.hasClass('details-trigger') && !$target.hasClass('item-details-trigger') && !$target.hasClass('search-trigger') && !$target.hasClass('clear-search-trigger')) {
                    $(document).trigger('show-learn-more');
                    return false;
                }
            }
        };
    }

})();
